import getCollection from '../../utils/db/getCollection'
import filterSelectablePromoSchedules from './filterSelectablePromoSchedules'
import formatPromoScheduleOption from './formatPromoScheduleOption'
import { PREMIUM_PROMO_SHOP_ID } from './promoScheduleConstants'

export const loadSelectablePromoSchedules = () =>
  getCollection({
    path: 'promoSchedules',
    docIdName: 'id',
    whereQueries: [{ fieldPath: 'shopId', op: '==', value: PREMIUM_PROMO_SHOP_ID }],
  }).then((schedules) => {
    const now = new Date()

    return filterSelectablePromoSchedules(schedules, now).map((schedule) =>
      formatPromoScheduleOption(schedule, now)
    )
  })

export default loadSelectablePromoSchedules
